"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isFunction = _interopRequireDefault(require("lodash/isFunction"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
// credit to https://github.com/kitze/conditional-wrap

var propTypes = {
  /** condition */
  condition: _propTypes["default"].bool,
  /** wrap */
  wrap: _propTypes["default"].func,
  /** children */
  children: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func])
};
var ConditionalWrap = function ConditionalWrap(_ref) {
  var condition = _ref.condition,
    wrap = _ref.wrap,
    children = _ref.children;
  return condition ? wrap(children) : (0, _isFunction["default"])(children) ? children() : children;
};
ConditionalWrap.propTypes = propTypes;
var _default = ConditionalWrap;
exports["default"] = _default;